(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  class BannerSlider extends HTMLElement {
    #controller = null;
    #current = 0;
    #timer = null;
    #preloadTimer = null;
    #observer = null;
    #isVisible = true;
    #temporarilyPaused = false;
    #userPaused = false;
    #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slider-slide]')];
      if (this.slides.length < 2) return;

      this.#controller = new AbortController();
      const { signal } = this.#controller;
      this.dots = [...this.querySelectorAll('[data-slider-dot]')];
      this.pauseButton = this.querySelector('[data-slider-pause]');
      this.autoplay = this.dataset.autoplay === 'true';
      this.delay = Number(this.dataset.autoplayDelay) || 7000;

      this.querySelector('[data-slider-previous]')?.addEventListener('click', () => this.#show(this.#current - 1), { signal });
      this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.#show(this.#current + 1), { signal });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.#show(Number(dot.dataset.sliderDot)), { signal });
      });
      this.pauseButton?.addEventListener('click', () => this.#toggleUserPause(), { signal });

      this.addEventListener('pointerenter', () => this.#setTemporaryPause(true), { signal });
      this.addEventListener('pointerleave', () => this.#setTemporaryPause(false), { signal });
      this.addEventListener('focusin', () => this.#setTemporaryPause(true), { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.#setTemporaryPause(false);
      }, { signal });
      document.addEventListener('visibilitychange', () => this.#schedule(), { signal });
      this.#reducedMotion.addEventListener('change', () => this.#schedule(), { signal });

      this.#observer = new IntersectionObserver(([entry]) => {
        this.#isVisible = entry.isIntersecting;
        this.#schedule();
      }, { threshold: 0.2 });
      this.#observer.observe(this);

      this.#preloadNext();
      this.#schedule();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#observer?.disconnect();
      window.clearTimeout(this.#timer);
      window.clearTimeout(this.#preloadTimer);
    }

    #show(index) {
      const nextIndex = (index + this.slides.length) % this.slides.length;
      if (nextIndex === this.#current) return;

      this.#hydrateSlide(this.slides[nextIndex]);
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        const link = slide.querySelector('[data-slide-link]');
        if (link) link.tabIndex = active ? 0 : -1;
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      this.#current = nextIndex;
      this.#preloadNext();
      this.#schedule();
    }

    #hydrateSlide(slide) {
      if (!slide || slide.dataset.hydrated === 'true') return;

      const source = slide.querySelector('source[data-srcset]');
      const image = slide.querySelector('[data-slider-image]');
      if (source?.dataset.srcset) {
        source.srcset = source.dataset.srcset;
        delete source.dataset.srcset;
      }
      if (image?.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        delete image.dataset.srcset;
      }
      if (image?.dataset.src) {
        image.src = image.dataset.src;
        image.loading = 'eager';
        delete image.dataset.src;
      }
      slide.dataset.hydrated = 'true';
    }

    #preloadNext() {
      window.clearTimeout(this.#preloadTimer);
      if (!this.autoplay || this.#reducedMotion.matches || navigator.connection?.saveData) return;
      const nextIndex = (this.#current + 1) % this.slides.length;
      const preloadDelay = Math.min(5000, Math.max(2500, this.delay - 2500));
      this.#preloadTimer = window.setTimeout(() => this.#hydrateSlide(this.slides[nextIndex]), preloadDelay);
    }

    #toggleUserPause() {
      this.#userPaused = !this.#userPaused;
      this.pauseButton.dataset.paused = String(this.#userPaused);
      this.pauseButton.setAttribute(
        'aria-label',
        this.#userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel
      );
      this.#schedule();
    }

    #setTemporaryPause(paused) {
      this.#temporarilyPaused = paused;
      this.#schedule();
    }

    #schedule() {
      window.clearTimeout(this.#timer);
      const shouldRun = this.autoplay
        && !this.#userPaused
        && !this.#temporarilyPaused
        && !this.#reducedMotion.matches
        && !navigator.connection?.saveData
        && !document.hidden
        && this.#isVisible;
      if (!shouldRun) return;

      this.#timer = window.setTimeout(() => this.#show(this.#current + 1), this.delay);
    }
  }

  if (!customElements.get('banner-slider')) {
    customElements.define('banner-slider', BannerSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-collection-tab]')];
      this.panels = [...this.querySelectorAll('[data-collection-panel]')];
      this.rails = [...this.querySelectorAll('[data-collection-rail]')].map((viewport) => {
        const carousel = viewport.closest('[data-collection-carousel]');
        return {
          viewport,
          slides: [...viewport.children],
          previousButton: carousel?.querySelector('[data-collection-previous]'),
          nextButton: carousel?.querySelector('[data-collection-next]'),
          frame: null
        };
      });

      for (const tab of this.tabs) {
        tab.addEventListener('click', () => this.activate(tab), { signal: this.controller.signal });
        tab.addEventListener('keydown', (event) => this.onKeydown(event), { signal: this.controller.signal });
      }

      for (const rail of this.rails) this.setupRail(rail);
      window.addEventListener('resize', () => {
        for (const rail of this.rails) this.requestRailUpdate(rail);
      }, { passive: true, signal: this.controller.signal });
      this.dataset.railReady = 'true';
    }

    disconnectedCallback() {
      this.controller?.abort();
      delete this.dataset.railReady;
      for (const rail of this.rails || []) {
        if (rail.frame) cancelAnimationFrame(rail.frame);
      }
    }

    activate(nextTab, moveFocus = false) {
      for (const tab of this.tabs) {
        const active = tab === nextTab;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      }

      for (const panel of this.panels) {
        panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
      }

      const activePanel = this.panels.find((panel) => !panel.hidden);
      const activeRail = this.rails.find((rail) => activePanel?.contains(rail.viewport));
      if (activeRail) this.requestRailUpdate(activeRail);

      nextTab.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });

      if (moveFocus) nextTab.focus();
    }

    setupRail(rail) {
      const { viewport, previousButton, nextButton } = rail;
      if (rail.slides.length < 2) {
        if (previousButton) previousButton.hidden = true;
        if (nextButton) nextButton.hidden = true;
        return;
      }

      previousButton?.addEventListener('click', () => this.moveRail(rail, -1), { signal: this.controller.signal });
      nextButton?.addEventListener('click', () => this.moveRail(rail, 1), { signal: this.controller.signal });
      viewport.addEventListener('scroll', () => this.requestRailUpdate(rail), { passive: true, signal: this.controller.signal });
      viewport.addEventListener('keydown', (event) => {
        if (event.target !== viewport || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        if (viewport.scrollWidth <= viewport.clientWidth + 1) return;
        event.preventDefault();
        this.moveRail(rail, event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal: this.controller.signal });
      this.requestRailUpdate(rail);
    }

    moveRail(rail, direction) {
      const currentIndex = this.getRailIndex(rail);
      const nextIndex = Math.min(Math.max(currentIndex + direction, 0), rail.slides.length - 1);
      if (nextIndex === currentIndex) return;
      const viewportStart = rail.viewport.getBoundingClientRect().left;
      const slideStart = rail.slides[nextIndex].getBoundingClientRect().left;
      rail.viewport.scrollBy({
        left: slideStart - viewportStart,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    getRailIndex(rail) {
      const viewportStart = rail.viewport.getBoundingClientRect().left;
      let currentIndex = 0;
      let smallestDistance = Infinity;

      for (const [index, slide] of rail.slides.entries()) {
        const distance = Math.abs(slide.getBoundingClientRect().left - viewportStart);
        if (distance >= smallestDistance) continue;
        smallestDistance = distance;
        currentIndex = index;
      }

      return currentIndex;
    }

    requestRailUpdate(rail) {
      if (rail.frame) cancelAnimationFrame(rail.frame);
      rail.frame = requestAnimationFrame(() => this.updateRail(rail));
    }

    updateRail(rail) {
      const viewportBounds = rail.viewport.getBoundingClientRect();
      const firstBounds = rail.slides[0]?.getBoundingClientRect();
      const lastBounds = rail.slides[rail.slides.length - 1]?.getBoundingClientRect();
      if (!firstBounds || !lastBounds) return;

      const hasOverflow = rail.viewport.scrollWidth > rail.viewport.clientWidth + 1;
      const edgeTolerance = 2;
      if (hasOverflow) {
        rail.viewport.tabIndex = 0;
        rail.viewport.setAttribute('aria-roledescription', 'carousel');
      } else {
        rail.viewport.removeAttribute('tabindex');
        rail.viewport.removeAttribute('aria-roledescription');
      }
      if (rail.previousButton) {
        rail.previousButton.hidden = !hasOverflow;
        rail.previousButton.setAttribute(
          'aria-disabled',
          firstBounds.left >= viewportBounds.left - edgeTolerance ? 'true' : 'false'
        );
      }
      if (rail.nextButton) {
        rail.nextButton.hidden = !hasOverflow;
        rail.nextButton.setAttribute(
          'aria-disabled',
          lastBounds.right <= viewportBounds.right + edgeTolerance ? 'true' : 'false'
        );
      }
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.activate(this.tabs[nextIndex], true);
    }
  }

  if (!customElements.get('collection-tabs')) {
    customElements.define('collection-tabs', CollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  for (const sortSelect of document.querySelectorAll('.collection-sort select')) {
    sortSelect.addEventListener('change', () => sortSelect.form?.requestSubmit());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-capture"] && !Shopify.designMode) return;
  try {
    
  class LeadCapture extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.dialog = this.querySelector('[data-lead-dialog]');
      this.openButtons = [...this.querySelectorAll('[data-lead-open]')];
      this.closeButtons = [...this.querySelectorAll('[data-lead-close]')];
      this.success = this.querySelector('[data-lead-success]');
      this.errors = this.querySelector('[data-lead-errors]');
      this.trigger = null;
      this.autoTimer = null;
      this.footerObserver = null;

      if (!this.dialog) return;

      this.setupFooterVisibility();

      for (const button of this.openButtons) {
        button.addEventListener('click', () => this.open(button), { signal: this.controller.signal });
      }
      for (const button of this.closeButtons) {
        button.addEventListener('click', () => this.dialog.close(), { signal: this.controller.signal });
      }

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, { signal: this.controller.signal });
      this.dialog.addEventListener('close', () => this.onClose(), { signal: this.controller.signal });

      const copyButton = this.querySelector('[data-copy-code]');
      copyButton?.addEventListener('click', () => this.copyCode(copyButton), { signal: this.controller.signal });

      if (this.success || this.errors) {
        this.open();
        requestAnimationFrame(() => (this.success || this.errors)?.focus());
      } else {
        this.setupAutoShow();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.footerObserver?.disconnect();
      if (this.autoTimer) window.clearTimeout(this.autoTimer);
    }

    open(trigger = null) {
      if (this.dialog.open) return;
      this.trigger = trigger;
      if (this.autoTimer) window.clearTimeout(this.autoTimer);
      this.rememberDismissal();
      this.dialog.showModal();
    }

    onClose() {
      this.rememberDismissal();
      this.trigger?.focus();
    }

    setupAutoShow() {
      if (this.dataset.autoShow !== 'true' || window.Shopify?.designMode || this.wasRecentlyDismissed()) return;
      this.autoTimer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 30000);
    }

    setupFooterVisibility() {
      const footer = document.querySelector('.site-footer');
      if (!footer || !('IntersectionObserver' in window)) return;

      this.footerObserver = new IntersectionObserver(([entry]) => {
        this.dataset.footerVisible = entry.isIntersecting ? 'true' : 'false';
      }, { threshold: 0.05 });
      this.footerObserver.observe(footer);
    }

    wasRecentlyDismissed() {
      try {
        const dismissedAt = Number(localStorage.getItem(this.dataset.storageKey));
        const frequency = Number(this.dataset.frequencyDays) * 86400000;
        return dismissedAt > 0 && Date.now() - dismissedAt < frequency;
      } catch (error) {
        return false;
      }
    }

    rememberDismissal() {
      try {
        localStorage.setItem(this.dataset.storageKey, String(Date.now()));
      } catch (error) {
        // Storage can be unavailable in private browsing; dismissal still works for this page view.
      }
    }

    async copyCode(button) {
      const code = button.dataset.copyCode;
      const label = button.querySelector('[data-copy-label]');
      let copied = false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (error) {
        copied = false;
      }

      if (!copied) {
        const textArea = document.createElement('textarea');
        textArea.value = code;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.append(textArea);
        textArea.select();

        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }

        textArea.remove();
      }

      if (label) label.textContent = copied ? this.dataset.copiedLabel : this.dataset.copyFailedLabel;
    }
  }

  if (!customElements.get('lead-capture')) {
    customElements.define('lead-capture', LeadCapture);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    #controller = null;
    #carouselController = null;
    #observer = null;
    #loaded = false;
    #carouselFrame = null;

    connectedCallback() {
      this.#controller = new AbortController();
      this.#setupCarousel();
      if (this.dataset.source === 'recommendations') return;

      if (!('IntersectionObserver' in window)) {
        this.#loaded = true;
        this.#load();
        return;
      }

      this.#observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting || this.#loaded) return;
        this.#loaded = true;
        this.#observer.disconnect();
        this.#load();
      }, { rootMargin: '400px 0px' });
      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#carouselController?.abort();
      this.#observer?.disconnect();
      if (this.#carouselFrame) cancelAnimationFrame(this.#carouselFrame);
    }

    #setupCarousel() {
      this.#carouselController?.abort();
      this.#carouselController = new AbortController();
      const signal = this.#carouselController.signal;

      this.carousel = this.querySelector('[data-recommendations-carousel]');
      this.viewport = this.querySelector('[data-recommendations-viewport]');
      this.slides = [...this.querySelectorAll('[data-recommendations-slide]')];
      this.previousButton = this.querySelector('[data-recommendations-previous]');
      this.nextButton = this.querySelector('[data-recommendations-next]');
      if (!this.carousel || !this.viewport || this.slides.length < 2) {
        if (this.previousButton) this.previousButton.hidden = true;
        if (this.nextButton) this.nextButton.hidden = true;
        return;
      }

      const requestUpdate = () => {
        if (this.#carouselFrame) cancelAnimationFrame(this.#carouselFrame);
        this.#carouselFrame = requestAnimationFrame(() => this.#updateCarousel());
      };

      this.previousButton?.addEventListener('click', () => this.#moveCarousel(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.#moveCarousel(1), { signal });
      this.viewport.addEventListener('scroll', requestUpdate, { passive: true, signal });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.target !== this.viewport) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.#moveCarousel(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      window.addEventListener('resize', requestUpdate, { passive: true, signal });
      requestUpdate();
    }

    #moveCarousel(direction) {
      if (!this.viewport || !this.slides.length) return;
      const currentIndex = this.#getCarouselIndex();
      const nextIndex = Math.min(Math.max(currentIndex + direction, 0), this.slides.length - 1);
      const viewportStart = this.viewport.getBoundingClientRect().left;
      const slideStart = this.slides[nextIndex].getBoundingClientRect().left;
      this.viewport.scrollBy({
        left: slideStart - viewportStart,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    #getCarouselIndex() {
      const viewportStart = this.viewport.getBoundingClientRect().left;
      let currentIndex = 0;
      let smallestDistance = Infinity;

      for (const [index, slide] of this.slides.entries()) {
        const distance = Math.abs(slide.getBoundingClientRect().left - viewportStart);
        if (distance >= smallestDistance) continue;
        smallestDistance = distance;
        currentIndex = index;
      }

      return currentIndex;
    }

    #updateCarousel() {
      if (!this.viewport || !this.slides.length) return;
      const viewportBounds = this.viewport.getBoundingClientRect();
      const firstBounds = this.slides[0].getBoundingClientRect();
      const lastBounds = this.slides[this.slides.length - 1].getBoundingClientRect();
      const hasOverflow = this.viewport.scrollWidth > this.viewport.clientWidth + 1;
      const edgeTolerance = 2;

      if (this.previousButton) {
        this.previousButton.hidden = !hasOverflow;
        this.previousButton.disabled = firstBounds.left >= viewportBounds.left - edgeTolerance;
      }
      if (this.nextButton) {
        this.nextButton.hidden = !hasOverflow;
        this.nextButton.disabled = lastBounds.right <= viewportBounds.right + edgeTolerance;
      }
    }

    async #load() {
      try {
        const response = await fetch(this.dataset.url, { signal: this.#controller.signal });
        if (!response.ok) return;

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = documentFragment.querySelector('product-recommendations');
        if (recommendations?.dataset.source !== 'recommendations') return;
        if (!recommendations.innerHTML.trim()) return;

        this.innerHTML = recommendations.innerHTML;
        this.dataset.source = 'recommendations';
        this.#setupCarousel();
      } catch (error) {
        if (error.name !== 'AbortError') console.error('Product recommendations failed to load', error);
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductDetails extends HTMLElement {
    #controller = null;
    #variants = [];
    #ctaObserver = null;
    #sectionObserver = null;
    #recommendationsObserver = null;
    #galleryImageObserver = null;
    #galleryVideoObserver = null;
    #galleryFrame = null;
    #galleryVideoFrame = null;
    #galleryVideoIntents = new WeakMap();
    #galleryVideoRequests = new WeakMap();
    #visibleGalleryVideos = new Set();
    #hasSeenPurchase = false;
    #primaryButtonVisible = false;
    #sectionVisible = true;
    #recommendationsVisible = false;

    connectedCallback() {
      this.#controller = new AbortController();
      const variantsNode = this.querySelector('[data-product-variants]');
      if (!variantsNode) return;

      this.#variants = JSON.parse(variantsNode.textContent);
      this.isMadeToOrder = this.dataset.madeToOrder === 'true';
      this.variantInput = this.querySelector('[data-variant-input]');
      this.fallback = this.querySelector('[data-variant-fallback]');
      this.button = this.querySelector('[data-add-to-cart]');
      this.buttonText = this.querySelector('[data-add-to-cart-text]');
      this.currentPrice = this.querySelector('[data-current-price]');
      this.comparePrice = this.querySelector('[data-compare-price]');
      this.availabilityWrap = this.querySelector('[data-product-availability-wrap]');
      this.availability = this.querySelector('[data-product-availability]');
      this.skuWrap = this.querySelector('[data-product-sku-wrap]');
      this.sku = this.querySelector('[data-product-sku]');
      this.dynamicCheckout = this.querySelector('[data-dynamic-checkout]');
      this.installmentForm = this.querySelector('[data-installment-form]');
      this.installmentVariant = this.querySelector('[data-installment-variant]');
      this.madeToOrderNote = this.querySelector('[data-made-to-order-note]');
      this.quantityInput = this.querySelector('[name="quantity"]');
      this.stickyPurchase = this.querySelector('[data-sticky-purchase]');
      this.stickyButton = this.querySelector('[data-sticky-add-to-cart]');
      this.stickyButtonText = this.querySelector('[data-sticky-add-to-cart-text]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.purchaseRegion = this.querySelector('.product-details__layout');
      this.recommendations = document.querySelector('product-recommendations');
      this.gallery = this.querySelector('.product-gallery');
      this.galleryItems = [...this.querySelectorAll('[data-gallery-item]')];
      this.galleryCounter = this.querySelector('[data-gallery-counter]');
      this.galleryCurrent = this.querySelector('[data-gallery-current]');
      // External provider iframes need their own player API; this controller manages Shopify-hosted videos.
      this.galleryVideos = [...this.querySelectorAll('video.product-gallery__video')];
      this.galleryVideoPlayButton = this.querySelector('[data-product-video-play]');
      this.sizeGuideDialog = this.querySelector('[data-size-guide-dialog]');
      this.sizeGuideOpens = [...this.querySelectorAll('[data-size-guide-open]')];
      this.sizeGuideClose = this.querySelector('[data-size-guide-close]');

      if (this.variantInput) this.variantInput.name = 'id';
      if (this.fallback) this.fallback.disabled = true;

      for (const input of this.querySelectorAll('[data-product-option]')) {
        input.addEventListener('change', this.#handleOptionChange.bind(this), { signal: this.#controller.signal });
      }

      this.#updateSelectedOptionLabels();
      this.#updateOptionAvailability();
      this.#setupGallery();
      this.#setupGalleryImages();
      this.#setupGalleryVideos();
      this.#setupSizeGuide();
      this.#setupStickyPurchase();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#ctaObserver?.disconnect();
      this.#sectionObserver?.disconnect();
      this.#recommendationsObserver?.disconnect();
      this.#galleryImageObserver?.disconnect();
      this.#galleryVideoObserver?.disconnect();
      for (const video of this.galleryVideos || []) this.#pauseGalleryVideo(video);
      this.#visibleGalleryVideos.clear();
      if (this.#galleryFrame) cancelAnimationFrame(this.#galleryFrame);
      if (this.#galleryVideoFrame) cancelAnimationFrame(this.#galleryVideoFrame);
    }

    #handleOptionChange() {
      const selectedInputs = [...this.querySelectorAll('[data-product-option]')]
        .filter((input) => input.type === 'hidden' || input.checked)
        .sort((first, second) => Number(first.dataset.optionPosition) - Number(second.dataset.optionPosition));
      const selectedValues = selectedInputs.map((input) => input.value);
      const variant = this.#variants.find((item) => item.options.every((option, index) => option === selectedValues[index]));

      this.#updateSelectedOptionLabels(selectedInputs);
      this.#updateOptionAvailability(selectedInputs);
      this.#updateVariant(variant);
    }

    #updateSelectedOptionLabels(selectedInputs = null) {
      const inputs = selectedInputs || [...this.querySelectorAll('[data-product-option]')]
        .filter((input) => input.type === 'hidden' || input.checked);

      for (const input of inputs) {
        const label = this.querySelector(`[data-selected-option-position="${input.dataset.optionPosition}"]`);
        if (label) label.textContent = input.value;
      }
    }

    #updateVariant(variant) {
      if (!variant) {
        if (this.variantInput) {
          this.variantInput.value = '';
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (this.installmentVariant) {
          this.installmentVariant.value = '';
          this.installmentVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (this.button) this.button.disabled = true;
        if (this.buttonText) this.buttonText.textContent = this.dataset.unavailableLabel;
        if (this.stickyButton) this.stickyButton.disabled = true;
        if (this.stickyButtonText) this.stickyButtonText.textContent = this.dataset.unavailableLabel;
        if (this.dynamicCheckout) this.dynamicCheckout.hidden = true;
        if (this.installmentForm) this.installmentForm.hidden = true;
        if (this.madeToOrderNote) this.madeToOrderNote.hidden = true;
        this.#updateProductMeta(null);
        return;
      }

      if (this.variantInput) {
        this.variantInput.value = variant.id;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (this.installmentVariant) {
        this.installmentVariant.value = variant.id;
        this.installmentVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const formattedPrice = this.#formatMoney(variant.price);
      if (this.currentPrice) this.currentPrice.textContent = formattedPrice;
      if (this.stickyPrice) this.stickyPrice.textContent = formattedPrice;

      if (this.comparePrice) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.comparePrice.hidden = !onSale;
        this.comparePrice.textContent = onSale ? this.#formatMoney(variant.compare_at_price) : '';
      }

      if (this.button) this.button.disabled = !variant.available;
      const madeToOrder = variant.available && this.isMadeToOrder;
      const purchaseLabel = variant.available
        ? (madeToOrder ? this.dataset.madeToOrderLabel : this.dataset.addLabel)
        : this.dataset.soldOutLabel;
      if (this.buttonText) this.buttonText.textContent = purchaseLabel;
      if (this.stickyButton) this.stickyButton.disabled = !variant.available;
      if (this.stickyButtonText) this.stickyButtonText.textContent = purchaseLabel;
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = !variant.available;
      if (this.installmentForm) this.installmentForm.hidden = !variant.available;
      if (this.madeToOrderNote) this.madeToOrderNote.hidden = !madeToOrder;
      this.#updateProductMeta(variant);

      if (this.quantityInput && variant.quantity_rule) {
        const minimum = variant.quantity_rule.min || 1;
        if (this.quantityInput.type !== 'hidden') {
          this.quantityInput.min = minimum;
          this.quantityInput.step = variant.quantity_rule.increment || 1;
          if (variant.quantity_rule.max) {
            this.quantityInput.max = variant.quantity_rule.max;
          } else {
            this.quantityInput.removeAttribute('max');
          }
        }
        if (Number(this.quantityInput.value) < minimum) {
          this.quantityInput.value = minimum;
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media && window.matchMedia('(max-width: 749px)').matches) {
        const media = document.getElementById(`ProductMedia-${this.dataset.sectionId}-${variant.featured_media.id}`);
        media?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    #updateOptionAvailability(selectedInputs = null) {
      const selected = selectedInputs || [...this.querySelectorAll('[data-product-option]')]
        .filter((input) => input.type === 'hidden' || input.checked);
      const selectedByPosition = new Map(selected.map((input) => [Number(input.dataset.optionPosition), input.value]));

      for (const input of this.querySelectorAll('input[type="radio"][data-product-option]')) {
        const candidateByPosition = new Map(selectedByPosition);
        candidateByPosition.set(Number(input.dataset.optionPosition), input.value);
        const available = this.#variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((value, index) => {
            const selectedValue = candidateByPosition.get(index + 1);
            return !selectedValue || value === selectedValue;
          });
        });
        const valueLabel = input.closest('.product-option__value');
        const status = valueLabel?.querySelector('[data-option-status]');
        valueLabel?.classList.toggle('product-option__value--unavailable', !available);
        if (status) status.textContent = available ? '' : ` — ${this.dataset.soldOutLabel}`;
      }
    }

    #updateProductMeta(variant) {
      if (this.availability && this.availabilityWrap) {
        const available = Boolean(variant?.available);
        this.availability.textContent = variant
          ? (available ? (this.isMadeToOrder ? this.dataset.madeToOrderLabel : this.dataset.availableLabel) : this.dataset.soldOutLabel)
          : this.dataset.unavailableLabel;
        this.availabilityWrap.classList.toggle('product-availability--unavailable', !available);
      }

      if (this.sku && this.skuWrap) {
        const sku = variant?.sku?.trim() || '';
        this.sku.textContent = sku;
        this.skuWrap.hidden = !sku;
      }
    }

    #setupGallery() {
      if (!this.gallery || this.galleryItems.length < 2 || !this.galleryCounter) return;

      const requestUpdate = () => {
        if (this.#galleryFrame) cancelAnimationFrame(this.#galleryFrame);
        this.#galleryFrame = requestAnimationFrame(() => this.#updateGalleryCounter());
      };

      this.gallery.addEventListener('scroll', requestUpdate, { passive: true, signal: this.#controller.signal });
      window.addEventListener('resize', requestUpdate, { passive: true, signal: this.#controller.signal });
      requestUpdate();
    }

    #setupGalleryImages() {
      const images = [...this.querySelectorAll('[data-product-gallery-image][data-src]')];
      if (!images.length) return;

      if (!('IntersectionObserver' in window)) {
        for (const image of images) this.#hydrateGalleryImage(image);
        return;
      }

      this.#galleryImageObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.#hydrateGalleryImage(entry.target);
          this.#galleryImageObserver?.unobserve(entry.target);
        }
      }, { rootMargin: '300px 0px' });

      for (const image of images) this.#galleryImageObserver.observe(image);
    }

    #setupGalleryVideos() {
      if (!this.galleryVideos.length) return;

      this.mobileGalleryVideoQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotionGalleryVideoQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.galleryVideoPlayButton?.addEventListener('click', () => {
        if (this.fallbackGalleryVideo) this.#playGalleryVideo(this.fallbackGalleryVideo, true);
      }, { signal: this.#controller.signal });

      for (const video of this.galleryVideos) {
        this.#prepareGalleryVideo(video);
        this.#pauseGalleryVideo(video);

        video.addEventListener('play', () => {
          if (this.#galleryVideoIntents.get(video) !== 'play') {
            video.pause();
            return;
          }
          this.#prepareGalleryVideo(video);
          if (this.fallbackGalleryVideo === video) this.#hideGalleryVideoFallback();
        }, { signal: this.#controller.signal });
        video.addEventListener('volumechange', () => {
          if (!video.muted) video.muted = true;
        }, { signal: this.#controller.signal });
      }

      const refreshPlayback = () => {
        this.#hideGalleryVideoFallback();
        for (const video of this.galleryVideos) {
          if (this.#visibleGalleryVideos.has(video) && !document.hidden) {
            this.#playGalleryVideo(video);
          } else {
            this.#pauseGalleryVideo(video);
          }
        }
      };

      this.mobileGalleryVideoQuery.addEventListener('change', refreshPlayback, { signal: this.#controller.signal });
      this.reducedMotionGalleryVideoQuery.addEventListener('change', refreshPlayback, { signal: this.#controller.signal });
      document.addEventListener('visibilitychange', refreshPlayback, { signal: this.#controller.signal });

      if (!('IntersectionObserver' in window)) {
        const requestSync = () => {
          if (this.#galleryVideoFrame) cancelAnimationFrame(this.#galleryVideoFrame);
          this.#galleryVideoFrame = requestAnimationFrame(() => this.#syncGalleryVideosWithoutObserver());
        };
        this.gallery?.addEventListener('scroll', requestSync, { passive: true, signal: this.#controller.signal });
        window.addEventListener('scroll', requestSync, { passive: true, signal: this.#controller.signal });
        window.addEventListener('resize', requestSync, { passive: true, signal: this.#controller.signal });
        requestSync();
        return;
      }

      this.#galleryVideoObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const video = entry.target.querySelector('video.product-gallery__video');
          if (!video) continue;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            this.#visibleGalleryVideos.add(video);
            this.#playGalleryVideo(video);
          } else {
            this.#visibleGalleryVideos.delete(video);
            this.#pauseGalleryVideo(video);
          }
        }
      }, { threshold: 0.6 });

      for (const video of this.galleryVideos) {
        const item = video.closest('[data-gallery-item]');
        if (item) this.#galleryVideoObserver.observe(item);
      }
    }

    #syncGalleryVideosWithoutObserver() {
      this.#visibleGalleryVideos.clear();

      if (this.mobileGalleryVideoQuery.matches && this.gallery) {
        const galleryStart = this.gallery.getBoundingClientRect().left;
        let activeItem = null;
        let smallestDistance = Infinity;

        for (const item of this.galleryItems) {
          const distance = Math.abs(item.getBoundingClientRect().left - galleryStart);
          if (distance >= smallestDistance) continue;
          smallestDistance = distance;
          activeItem = item;
        }

        const activeVideo = activeItem?.querySelector('video.product-gallery__video');
        const activeBounds = activeItem?.getBoundingClientRect();
        const activeItemIsVisible = activeBounds
          && activeBounds.bottom > 0
          && activeBounds.top < window.innerHeight
          && activeBounds.right > 0
          && activeBounds.left < window.innerWidth;
        if (activeVideo && activeItemIsVisible) this.#visibleGalleryVideos.add(activeVideo);
      } else {
        for (const video of this.galleryVideos) {
          const bounds = video.closest('[data-gallery-item]')?.getBoundingClientRect();
          if (!bounds) continue;
          const intersectsViewport = bounds.bottom > 0
            && bounds.top < window.innerHeight
            && bounds.right > 0
            && bounds.left < window.innerWidth;
          if (intersectsViewport) this.#visibleGalleryVideos.add(video);
        }
      }

      for (const video of this.galleryVideos) {
        if (this.#visibleGalleryVideos.has(video) && !document.hidden) {
          this.#playGalleryVideo(video);
        } else {
          this.#pauseGalleryVideo(video);
        }
      }
    }

    #prepareGalleryVideo(video) {
      video.autoplay = false;
      video.controls = false;
      video.defaultMuted = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('autoplay');
      video.removeAttribute('controls');
    }

    async #playGalleryVideo(video, userInitiated = false) {
      if (document.hidden) {
        this.#pauseGalleryVideo(video);
        return;
      }

      this.#prepareGalleryVideo(video);

      const automaticPlaybackDisabled = !userInitiated
        && this.mobileGalleryVideoQuery.matches
        && (
          this.reducedMotionGalleryVideoQuery.matches
          || navigator.connection?.saveData
        );

      if (automaticPlaybackDisabled) {
        this.#pauseGalleryVideo(video);
        this.#showGalleryVideoFallback(video);
        return;
      }

      this.#galleryVideoIntents.set(video, 'play');
      const requestId = (this.#galleryVideoRequests.get(video) || 0) + 1;
      this.#galleryVideoRequests.set(video, requestId);

      try {
        await video.play();
        if (this.#galleryVideoRequests.get(video) !== requestId) {
          if (
            this.#galleryVideoIntents.get(video) !== 'play'
            || !this.#visibleGalleryVideos.has(video)
            || document.hidden
          ) video.pause();
          return;
        }
        if (video.paused) {
          this.#showGalleryVideoFallback(video);
          return;
        }
        if (this.fallbackGalleryVideo === video) this.#hideGalleryVideoFallback();
      } catch (error) {
        if (this.#galleryVideoRequests.get(video) !== requestId) return;
        this.#showGalleryVideoFallback(video);
      }
    }

    #pauseGalleryVideo(video) {
      this.#galleryVideoIntents.set(video, 'pause');
      this.#galleryVideoRequests.set(video, (this.#galleryVideoRequests.get(video) || 0) + 1);
      video.pause();
      if (this.fallbackGalleryVideo === video) this.#hideGalleryVideoFallback();
    }

    #showGalleryVideoFallback(video) {
      this.#hideGalleryVideoFallback();
      if (!this.mobileGalleryVideoQuery.matches || !this.#visibleGalleryVideos.has(video)) return;

      this.fallbackGalleryVideo = video;
      if (this.galleryVideoPlayButton) this.galleryVideoPlayButton.hidden = false;
    }

    #hideGalleryVideoFallback() {
      this.fallbackGalleryVideo = null;
      if (this.galleryVideoPlayButton) this.galleryVideoPlayButton.hidden = true;
    }

    #hydrateGalleryImage(image) {
      if (!image.dataset.src) return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
    }

    #updateGalleryCounter() {
      const galleryStart = this.gallery.getBoundingClientRect().left;
      let currentIndex = 0;
      let smallestDistance = Infinity;

      this.galleryItems.forEach((item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - galleryStart);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          currentIndex = index;
        }
      });

      const current = currentIndex + 1;
      if (this.galleryCurrent) this.galleryCurrent.textContent = current;
      if (this.galleryCounter.dataset.labelTemplate) {
        this.galleryCounter.setAttribute('aria-label', this.galleryCounter.dataset.labelTemplate.replace('__CURRENT__', current));
      }
    }

    #setupSizeGuide() {
      if (!this.sizeGuideDialog || !this.sizeGuideOpens.length || !this.sizeGuideClose) return;

      const sizeGuideTitle = this.sizeGuideDialog.querySelector('h2')?.textContent.trim() || '';
      for (const image of this.sizeGuideDialog.querySelectorAll('img')) {
        if (!image.alt) image.alt = sizeGuideTitle;
        const setImageDimensions = () => {
          if (!image.hasAttribute('width') && image.naturalWidth) image.setAttribute('width', image.naturalWidth);
          if (!image.hasAttribute('height') && image.naturalHeight) image.setAttribute('height', image.naturalHeight);
        };
        if (image.complete) {
          setImageDimensions();
        } else {
          image.addEventListener('load', setImageDimensions, { once: true, signal: this.#controller.signal });
        }
      }

      for (const trigger of this.sizeGuideOpens) {
        trigger.addEventListener('click', () => {
          this.sizeGuideTrigger = trigger;
          this.sizeGuideDialog.showModal();
        }, { signal: this.#controller.signal });
      }
      this.sizeGuideClose.addEventListener('click', () => this.sizeGuideDialog.close(), { signal: this.#controller.signal });
      this.sizeGuideDialog.addEventListener('click', (event) => {
        if (event.target === this.sizeGuideDialog) this.sizeGuideDialog.close();
      }, { signal: this.#controller.signal });
      this.sizeGuideDialog.addEventListener('close', () => this.sizeGuideTrigger?.focus(), { signal: this.#controller.signal });
    }

    #setupStickyPurchase() {
      if (!this.stickyPurchase || !this.button || !this.purchaseRegion) return;

      this.#ctaObserver = new IntersectionObserver(([entry]) => {
        this.#primaryButtonVisible = entry.isIntersecting;
        if (entry.isIntersecting) this.#hasSeenPurchase = true;
        this.#updateStickyVisibility();
      }, { threshold: 0.2 });

      this.#sectionObserver = new IntersectionObserver(([entry]) => {
        this.#sectionVisible = entry.isIntersecting;
        this.#updateStickyVisibility();
      });

      if (this.recommendations) {
        this.#recommendationsObserver = new IntersectionObserver(([entry]) => {
          this.#recommendationsVisible = entry.isIntersecting;
          this.#updateStickyVisibility();
        }, { rootMargin: '0px 0px -75% 0px' });
      }

      this.#ctaObserver.observe(this.button);
      this.#sectionObserver.observe(this.purchaseRegion);
      this.#recommendationsObserver?.observe(this.recommendations);

      const updateVisibility = this.#updateStickyVisibility.bind(this);
      window.addEventListener('scroll', updateVisibility, { passive: true, signal: this.#controller.signal });
      window.addEventListener('resize', updateVisibility, { passive: true, signal: this.#controller.signal });
      this.#updateStickyVisibility();
    }

    #updateStickyVisibility() {
      if (!this.stickyPurchase || !this.button) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const hasPassedPrimaryButton = this.#hasSeenPurchase && this.button.getBoundingClientRect().top < 0;
      const shouldShow = isMobile && this.#sectionVisible && !this.#recommendationsVisible && !this.#primaryButtonVisible && hasPassedPrimaryButton;
      this.stickyPurchase.hidden = !shouldShow;
    }

    #formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang, {
        style: 'currency',
        currency: this.dataset.currency
      }).format(cents / 100);
    }
  }

  if (!customElements.get('product-details')) {
    customElements.define('product-details', ProductDetails);
  }

  } catch(e) { console.error(e); }
})();
})();
